/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 18/08/2020.
 * @module TRUCK CONSTANTS
 */

import { head, last } from "lodash";
import StartPoint from "../images/start.png";
import StopPoint from "../images/stop.png";
import EndPoint from "../images/flag_end.png";
import OverFourHours from "../icon/Car icon/Artboard 42.png";
import OverMaxSpeed from "../icon/Car icon/Artboard 55.png";
import DeviceBroken from "../icon/Car icon/Artboard 71.png";
import ExpiredSim from "../icon/Car icon/drivingExpireSim1.png";
import TruckOverSpeed1 from "../icon/Car icon/overSpeed1.png";
import TruckOverSpeed2 from "../icon/Car icon/overSpeed2.png";
import TruckOverSpeed3 from "../icon/Car icon/overSpeed3.png";
import TruckOverSpeed4 from "../icon/Car icon/overSpeed4.png";
import TruckOverSpeed5 from "../icon/Car icon/overSpeed5.png";
import TruckOverSpeed6 from "../icon/Car icon/overSpeed6.png";
import TruckOverSpeed7 from "../icon/Car icon/overSpeed7.png";
import TruckOverSpeed8 from "../icon/Car icon/overSpeed8.png";
import TruckShutDown1 from "../icon/Car icon/shutDown1.png";
import TruckShutDown2 from "../icon/Car icon/shutDown2.png";
import TruckShutDown3 from "../icon/Car icon/shutDown3.png";
import TruckShutDown4 from "../icon/Car icon/shutDown4.png";
import TruckShutDown5 from "../icon/Car icon/shutDown5.png";
import TruckShutDown6 from "../icon/Car icon/shutDown6.png";
import TruckShutDown7 from "../icon/Car icon/shutDown7.png";
import TruckShutDown8 from "../icon/Car icon/shutDown8.png";
import TruckStop1 from "../icon/Car icon/stop1.png";
import TruckStop2 from "../icon/Car icon/stop2.png";
import TruckStop3 from "../icon/Car icon/stop3.png";
import TruckStop4 from "../icon/Car icon/stop4.png";
import TruckStop5 from "../icon/Car icon/stop5.png";
import TruckStop6 from "../icon/Car icon/stop6.png";
import TruckStop7 from "../icon/Car icon/stop7.png";
import TruckStop8 from "../icon/Car icon/stop8.png";
import TruckDriving1 from "../icon/Car icon/driving1.png";
import TruckDriving2 from "../icon/Car icon/driving2.png";
import TruckDriving3 from "../icon/Car icon/driving3.png";
import TruckDriving4 from "../icon/Car icon/driving4.png";
import TruckDriving5 from "../icon/Car icon/driving5.png";
import TruckDriving6 from "../icon/Car icon/driving6.png";
import TruckDriving7 from "../icon/Car icon/driving7.png";
import TruckDriving8 from "../icon/Car icon/driving8.png";
import TruckShutDownLostGps1 from "../icon/Car icon/shutDownLostGps1.png";
import TruckShutDownLostGps2 from "../icon/Car icon/shutDownLostGps2.png";
import TruckShutDownLostGps3 from "../icon/Car icon/shutDownLostGps3.png";
import TruckShutDownLostGps4 from "../icon/Car icon/shutDownLostGps4.png";
import TruckShutDownLostGps5 from "../icon/Car icon/shutDownLostGps5.png";
import TruckShutDownLostGps6 from "../icon/Car icon/shutDownLostGps6.png";
import TruckShutDownLostGps7 from "../icon/Car icon/shutDownLostGps7.png";
import TruckShutDownLostGps8 from "../icon/Car icon/shutDownLostGps8.png";
import TruckStopLostGps1 from "../icon/Car icon/stopLostGps1.png";
import TruckStopLostGps2 from "../icon/Car icon/stopLostGps2.png";
import TruckStopLostGps3 from "../icon/Car icon/stopLostGps3.png";
import TruckStopLostGps4 from "../icon/Car icon/stopLostGps4.png";
import TruckStopLostGps5 from "../icon/Car icon/stopLostGps5.png";
import TruckStopLostGps6 from "../icon/Car icon/stopLostGps6.png";
import TruckStopLostGps7 from "../icon/Car icon/stopLostGps7.png";
import TruckStopLostGps8 from "../icon/Car icon/stopLostGps8.png";
import TruckDrivingLostGps1 from "../icon/Car icon/drivingLostGps1.png";
import TruckDrivingLostGps2 from "../icon/Car icon/drivingLostGps2.png";
import TruckDrivingLostGps3 from "../icon/Car icon/drivingLostGps3.png";
import TruckDrivingLostGps4 from "../icon/Car icon/drivingLostGps4.png";
import TruckDrivingLostGps5 from "../icon/Car icon/drivingLostGps5.png";
import TruckDrivingLostGps6 from "../icon/Car icon/drivingLostGps6.png";
import TruckDrivingLostGps7 from "../icon/Car icon/drivingLostGps7.png";
import TruckDrivingLostGps8 from "../icon/Car icon/drivingLostGps8.png";
import TruckDrivingLostGms1 from "../icon/Car icon/shutDownLostGms1.png";
import TruckDrivingLostGms2 from "../icon/Car icon/shutDownLostGms2.png";
import TruckDrivingLostGms3 from "../icon/Car icon/shutDownLostGms3.png";
import TruckDrivingLostGms4 from "../icon/Car icon/shutDownLostGms4.png";
import TruckDrivingLostGms5 from "../icon/Car icon/shutDownLostGms5.png";
import TruckDrivingLostGms6 from "../icon/Car icon/shutDownLostGms6.png";
import TruckDrivingLostGms7 from "../icon/Car icon/shutDownLostGms7.png";
import TruckDrivingLostGms8 from "../icon/Car icon/shutDownLostGms8.png";
import TruckRepair from "../icon/Car icon/truckRepair.png";
import TruckNoInfo from "../icon/Car icon/truckNoInfo.png";
import TruckAcquy from "../icon/Car icon/truckAcquy.png";
import TruckOtherIncident from "../icon/Car icon/other_incident.png";
import React from "react";
import dayjs from "dayjs";

// Action constants
export const MODULE_NAME = "TRUCK/";

// Actions type
export const BROWSE_LICENCE_PLATE = `${MODULE_NAME}BROWSE_LICENCE_PLATE`;
export const BROWSE_VEHICLE_ROUTE = `${MODULE_NAME}BROWSE_VEHICLE_ROUTE`;
export const VEHICLE_SEARCH = `${MODULE_NAME}VEHICLE_SEARCH`;
export const BROWSE_TRUCKER_INFO = `${MODULE_NAME}/TRUCKER_INFO`;
export const BROWSE_FIRMWARE_INFO = `${MODULE_NAME}/FIRMWARE_INFO`;
export const BROWSE_DEVICE_INFO = `${MODULE_NAME}/DEVICE_INFO`;

export const WORKING_STATUS = {
  ACTIVE: {
    text: "Online",
    color: "#069255"
  },
  NO_GPS: {
    text: "Không có GPS",
    color: "#ffc107"
  },
  TEMPORARY_DOWN: {
    text: "Tạm dừng hoạt động",
    color: "#bdbdbd"
  },
  DOWN: {
    text: "Offline",
    color: "#dc3545"
  }
};
export const TRUCK_STATUSES = {
  online: {
    id: "online",
    label: "Tất cả",
    status: "online",
    color: "grey"
  },
  1: {
    id: "1",
    label: "Tắt máy",
    status: "shutdown",
    color: "dark",
    icon: {
      1: TruckShutDown1,
      2: TruckShutDown2,
      3: TruckShutDown3,
      4: TruckShutDown4,
      5: TruckShutDown5,
      6: TruckShutDown6,
      7: TruckShutDown7,
      8: TruckShutDown8
    }
  },
  2: {
    id: "2",
    label: "Dừng đỗ",
    status: "stop",
    color: "slategrey",
    icon: {
      1: TruckStop1,
      2: TruckStop2,
      3: TruckStop3,
      4: TruckStop4,
      5: TruckStop5,
      6: TruckStop6,
      7: TruckStop7,
      8: TruckStop8
    }
  },
  3: {
    id: "3",
    label: "Đang di chuyển",
    status: "running",
    color: "#069255",
    icon: {
      1: TruckDriving1,
      2: TruckDriving2,
      3: TruckDriving3,
      4: TruckDriving4,
      5: TruckDriving5,
      6: TruckDriving6,
      7: TruckDriving7,
      8: TruckDriving8
    }
  },
  5: {
    id: "5",
    label: "Tạm dừng hoạt động",
    status: "unavailable",
    color: "yellow",
    icon: {
      1: TruckDrivingLostGms1
    }
  },
  41: {
    id: "41",
    label: "Mất tín hiệu",
    status: "lost_signal__shutdown",
    color: "grey",
    icon: {
      1: TruckShutDownLostGps1,
      2: TruckShutDownLostGps2,
      3: TruckShutDownLostGps3,
      4: TruckShutDownLostGps4,
      5: TruckShutDownLostGps5,
      6: TruckShutDownLostGps6,
      7: TruckShutDownLostGps7,
      8: TruckShutDownLostGps8
    }
  },
  42: {
    id: "42",
    label: "Mất tín hiệu",
    status: "lost_signal__stop",
    color: "grey",
    icon: {
      1: TruckStopLostGps1,
      2: TruckStopLostGps2,
      3: TruckStopLostGps3,
      4: TruckStopLostGps4,
      5: TruckStopLostGps5,
      6: TruckStopLostGps6,
      7: TruckStopLostGps7,
      8: TruckStopLostGps8
    }
  },
  43: {
    id: "43",
    label: "Mất tín hiệu",
    status: "lost_signal__running",
    color: "grey",
    icon: {
      1: TruckDrivingLostGps1,
      2: TruckDrivingLostGps2,
      3: TruckDrivingLostGps3,
      4: TruckDrivingLostGps4,
      5: TruckDrivingLostGps5,
      6: TruckDrivingLostGps6,
      7: TruckDrivingLostGps7,
      8: TruckDrivingLostGps8
    }
  },
  44: {
    id: "44",
    label: "Mất tín hiệu",
    status: "lost_signal__default",
    color: "grey",
    icon: {
      1: TruckDrivingLostGms1,
      2: TruckDrivingLostGms2,
      3: TruckDrivingLostGms3,
      4: TruckDrivingLostGms4,
      5: TruckDrivingLostGms5,
      6: TruckDrivingLostGms6,
      7: TruckDrivingLostGms7,
      8: TruckDrivingLostGms8
    }
  },
  // offline: {
  //   id: "offline",
  //   label: "Tất cả",
  //   status: "offline",
  //   color: "grey"
  // },
  offline: {
    id: "offline",
    label: "Thiết bị hỏng",
    status: "offline",
    color: "yellow",
    icon: {
      // "1": TruckDrivingLostGms1
      1: DeviceBroken
    }
  },
  unavailable: {
    id: "unavailable",
    label: "Tạm dừng hoạt động",
    status: "unavailable",
    color: "yellow",
    icon: {
      1: TruckDrivingLostGms1
    }
  },
  over_four_hours: {
    id: "over_four_hours",
    label: "Xe chạy quá 4 tiếng",
    status: "over_four_hours",
    color: "grey",
    icon: {
      1: OverFourHours
    }
  },
  over_max_speed: {
    id: "over_max_speed",
    label: "Xe chạy quá tốc độ",
    status: "over_max_speed",
    color: "grey",
    icon: {
      1: OverMaxSpeed
    }
  },
  sim_expired: {
    id: "sim_expired",
    label: "Xe hết hạn sim",
    status: "sim_expired",
    color: "grey",
    icon: {
      1: ExpiredSim
    }
  },
  offline_1: {
    id: "offline_1",
    label: "Xe tai nạn/ bảo dưỡng ở gara",
    status: "offline_1",
    color: "grey",
    icon: {
      1: TruckRepair
    }
  },
  offline_2: {
    id: "offline_2",
    label: "Hết bình/ tháo bình acquy",
    status: "offline_2",
    color: "grey",
    icon: {
      1: TruckAcquy
    }
  },
  offline_3: {
    id: "offline_3",
    label: "Sự cố khác",
    status: "offline_3",
    color: "grey",
    icon: {
      1: TruckOtherIncident
    }
  },
  offline_4: {
    id: "offline_4",
    label: "Chưa có thông tin",
    status: "offline_4",
    color: "grey",
    icon: {
      1: TruckNoInfo
    }
  },
  default: TruckDriving1
};

export const OVER_SPEED_ICON_LIST = {
  1: TruckOverSpeed1,
  2: TruckOverSpeed2,
  3: TruckOverSpeed3,
  4: TruckOverSpeed4,
  5: TruckOverSpeed5,
  6: TruckOverSpeed6,
  7: TruckOverSpeed7,
  8: TruckOverSpeed8
};
export const PAGINATION = {
  limit: 20,
  offset: 1
};

export const VEHICLE_TYPE = [
  {
    id: "car",
    name: "Xe ô tô con"
  },
  {
    id: "passenger_car",
    name: "Xe ô tô chở người"
  },
  {
    id: "bus",
    name: "Xe Buýt"
  },
  {
    id: "truck",
    name: "Ô tô tải"
  },
  {
    id: "semi–trailer",
    name: "Ô tô đầu kéo sơ mi rơ mooc"
  },
  {
    id: "motorbike",
    name: "Xe mô tô"
  },
  {
    id: "trailer",
    name: "Ô tô đầu kéo rơ mooc"
  },
  {
    id: "diff_trailer",
    name: "Ô tô kéo khác"
  },
  {
    id: "specialized_car",
    name: "Ô tô chuyên dụng (trừ ô tô trộn vữa, ô tô trộn bê tông)"
  },
  {
    id: "car_mix_mortar",
    name: "Ô tô trộn vữa "
  },
  {
    id: "concrete_mixer_car",
    name: "Ô tô trộn bê tông"
  },
  {
    id: "tanker_car",
    name: "Ô tô xi téc"
  }
];

export const NUMBER_OF_SEATS = [
  {
    id: "over_thirty",
    name: "Trên 30 chỗ"
  },
  {
    id: "less_thirty",
    name: "Dưới 30 chỗ"
  }
];

export const weights = [
  {
    id: "1.25",
    name: "1.25 Tấn"
  },
  {
    id: "1.9",
    name: "1.9 Tấn"
  },
  {
    id: "5.0",
    name: "5.0 Tấn"
  },
  {
    id: "8.0",
    name: "8.0 Tấn"
  }
];

export const MAX_SPEED = [
  {
    id: "60",
    name: "60 km/h"
  },
  {
    id: "70",
    name: "70 km/h"
  },
  {
    id: "80",
    name: "80 km/h"
  },
  {
    id: "90",
    name: "90 km/h"
  }
];

export const LICENCE_TYPE = [
  {
    id: "A1",
    name: "A1"
  },
  {
    id: "A2",
    name: "A2"
  },
  {
    id: "A3",
    name: "A3"
  },
  {
    id: "A4",
    name: "A4"
  },
  {
    id: "B1",
    name: "B1"
  },
  {
    id: "B2",
    name: "B2"
  },
  {
    id: "C",
    name: "C"
  },
  {
    id: "D",
    name: "D"
  },
  {
    id: "E",
    name: "E"
  }
];

export const REPORT_TYPE = [
  {
    id: "type1",
    name: "Chi tiết vi phạm tốc độ xe chạy"
  },
  {
    id: "type2",
    name: "Thống kê vi phạm về tốc độ theo đơn vị vận tải"
  },
  {
    id: "type3",
    name: "Chi tiết vi phạm thời gian lái xe liên tục (4 giờ)"
  },
  {
    id: "type4",
    name: "Chi tiết vi phạm thời gian lái xe liên tục trong ngày (10 giờ)"
  },
  {
    id: "type5",
    name: "Tổng hợp tình hình vi phạm theo đơn vị vận tải"
  },
  {
    id: "type6",
    name: "Chi tiết vi phạm truyền dữ liệu theo đơn vị vận tải"
  }
];

export const ENTERPRISE_REPORT_TYPE = [
  {
    id: "type1",
    name: "Báo cáo tổng hợp hoạt động"
  },
  {
    id: "type2",
    name: "Báo cáo chi tiết hoạt động"
  },
  {
    id: "type4",
    name: "Báo cáo tổng hợp qua điểm chốt"
  },
  {
    id: "type3",
    name: "Báo cáo chi tiết qua điểm chốt"
  },
  {
    id: "type5",
    name: "Báo cáo vi phạm dừng đỗ"
  }
];

export const DEVICE_STATUS_REPORT_TYPE = [
  {
    id: "type1",
    name: "Báo cáo mất tín hiệu"
  }
];

export const REPORT_DATE_TIME_FORMAT_HOURS_MINUTE_SECOND =
  "YYYY/MM/DD HH:mm:ss";
export const TYPE_OF_OPERATION =
  "Xe tải - Vận chuyển hàng hóa không phải container";

export const API_UPLOAD_FIRMWARE = "/firmware-management/firmwares";

export const LIMIT_DATE = 2678399;

export const LIMIT_DATE_TYPE_1 = 345599;
export const LIMIT_DATE_TYPE_2 = 86399;

export const LIST_LICENSE_PLATE_MULTIPLE = ["type2", "type3", "type5", "type6"];

export const REPORT_73_DATE_FORMAT = "YYYY/DD/MM";

export const TIME_DRIVE_CONTINUE_4_HOURS_DEFAULT = 240;

export const CHARACTER_NO_DATA_DEFAULT = "-";

export const NO_CHECKIN = "Chưa có tài xế checkin";

export const TRUCKER_WORK_STATUS = {
  1: "Đã nghỉ",
  2: "Tạm nghỉ",
  3: "Đang làm việc"
};

export const DATE_HOURS_MINUTE_SECOND_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const DATE_HOURS_MINUTE_FORMAT = "DD/MM/YYYY HH:mm";

export const DATE_FORMAT = "DD/MM/YYYY";

export const LIST_FILTER_OF_MAP = [
  {
    key: "station",
    value: "Kho"
  },
  {
    key: "baixe",
    value: "Điểm dừng"
  },
  {
    key: "plane",
    value: "Sân bay"
  },
  {
    key: "bot",
    value: "BOT"
  },
  {
    key: "gas",
    value: "Trạm xăng"
  },
  {
    key: "now",
    value: "Now"
  },
  {
    key: "parking",
    value: "Bãi đỗ xe"
  },
  {
    key: "shop",
    value: "Shop"
  },
  {
    key: "post_office",
    value: "Văn phòng"
  }
];

export const LIST_STOP_TYPE = {
  station: "Kho",
  shop: "Shop",
  baixe: "Điểm dừng",
  post_office: "Văn phòng",
  plane: "Sân bay",
  now: "Now",
  bot: "BOT",
  parking: "Bãi đỗ xe"
};
export const MAP_ROUTING_POINT_ICON = {
  start: StartPoint,
  stop: StopPoint,
  end: EndPoint,
  truck: {
    icon: {
      1: TruckDriving1,
      2: TruckDriving2,
      3: TruckDriving3,
      4: TruckDriving4,
      5: TruckDriving5,
      6: TruckDriving6,
      7: TruckDriving7,
      8: TruckDriving8
    }
  }
};
export const DEVICE_STATUS = {
  WORKING: "Đã lắp",
  NEW: "Chưa sử dụng",
  DISABLE: "Hỏng"
};

export const BASE_API_TRACKER = "https://gmap-api-gw.ghtk.vn";
export const API_TRACKER_KEY = "jEV7T9eEGfnVzuQY";
export const ENTERPRISE_REPORT_DATE_FORMAT = "YYYY/DD/MM";

export const ENTERPRISE_REPORT_DATE_TIME_FORMAT = "YYYY/DD/MM HH:mm";

export const CAMERA_MONITOR_RULES = [
  {
    value: 1,
    label: "Tự ý bán tài sản công ty"
  },
  {
    value: 2,
    label:
      "Quăng ném, tác động tiêu cực lên hàng hoá/CCDC (Làm vỡ, dẫm, đạp, để hàng hoá nơi ẩm ướt,...)"
  },
  {
    value: 3,
    label: "Đi trên lego"
  },
  {
    value: 4,
    label:
      "Đóng/mở cửa không đúng thời gian quy định/Ra khỏi kho không có sự đồng ý của Quản lý"
  },
  {
    value: 5,
    label: "Không tuân thủ quy định kiểm tra an ninh, luồng an ninh"
  },
  {
    value: 6,
    label: "Mang các vật dụng khác ngoài danh sách được mang vào kho"
  },
  {
    value: 7,
    label:
      "Không tuân thủ thời gian làm việc theo quy định (Đi muộn, về sớm, ngủ trong giờ làm việc,...)"
  },
  {
    value: 8,
    label:
      "Làm việc riêng, sử dụng điện thoại cho mục đích cá nhân trong giờ làm việc"
  },
  {
    value: 9,
    label: "Đồng phục/tác phong/lời nói không chuẩn mực"
  },
  {
    value: 10,
    label: "Để xe sai vị trí trong khung giờ vận hành"
  }
];

export const CAMERA_MONITOR_DRIVER = [
  {
    value: 1,
    label:
      "Quăng ném, tác động tiêu cực lên hàng hoá/CCDC (Làm vỡ, dẫm, đạp, để hàng hoá nơi ẩm ướt,...)"
  },
  { value: 2, label: "Lái xe tự chốt, trữ seal, tự ý lấy hàng ra khỏi kho" },
  { value: 3, label: "Chở hàng/người ngoài, sử dụng xe vào mục đích riêng" },
  {
    value: 4,
    label: "Mang các vật dụng khác ngoài danh sách cho phép vào cabin xe tải"
  },
  { value: 5, label: "Tụ tập, sử dụng chất kích thích trong cabin xe tải" },
  {
    value: 6,
    label: "Làm việc riêng (Call video, xem điện thoại,...) khi lái xe"
  },
  { value: 7, label: "Thay đổi cấu trúc xe" },
  { value: 8, label: "Không tham gia lên/xuống tải cùng XLHH" },
  { value: 9, label: "Cabin, thùng xe không đạt 5S" },
  { value: 10, label: "Đồng phục không đúng quy định" }
];

export function renderMessage(item) {
  let urlRegex = /(https?:\/\/[^\s]+)/g;
  let text = item;
  let url = text.match(urlRegex);
  let message = text.replace(url, "");
  return (
    <div style={{ textAlign: "center" }}>
      <span>{message}</span>
      <a href={url} target="_blank" rel="noreferrer">
        {url}
      </a>
    </div>
  );
}

export function DataURIToBlob(dataURI) {
  const splitDataURI = dataURI.split(",");
  const byteString =
    splitDataURI[0].indexOf("base64") >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

  return new Blob([ia], { type: mimeString });
}

export function getBase64Image(imgUrl) {
  return new Promise(function (resolve) {
    let image = document.createElement("img");
    image.src = imgUrl;
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = function () {
      let canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0);
      let dataURL = canvas.toDataURL("image/png");
      resolve(dataURL);
    };
  });
}

export const RANGE_PICKER_RANGES_CHART = [
  { label: "Hôm nay", value: [dayjs(), dayjs()] },
  {
    label: "Hôm qua",
    value: [dayjs().subtract(1, "days"), dayjs().subtract(1, "days")]
  },
  {
    label: "3 ngày trước",
    value: [dayjs().subtract(3, "days"), dayjs()]
  },
  {
    label: "7 ngày trước",
    value: [dayjs().subtract(7, "days"), dayjs()]
  },
  {
    label: "30 ngày trước",
    value: [dayjs().subtract(30, "days"), dayjs()]
  }
];
